import api from "../utils/api";
import {baseURL} from "../settings.js/dev";

export const createCampaignMember = (payload) => () =>
    api.post(baseURL, `/salesforce/campaign-member/create`, payload).then((response) => {
        return response;
    });